import { isUndefined } from 'lodash';

const defaultState = {
  activeChargerIds: [],
  columnsConfig: [],
  chargers: [],
  fwList: [],
  selectedFwVersion: null,
  isConfirmationDialogOpened: false,
};

function multiFwUpdateList(state = defaultState, action) {
  switch (action.type) {
    case 'CLEAR_STATE':
      return defaultState;
    case 'LIST_SET_CHARGERS':
      return { ...state, chargers: action.chargers };
    case 'SET_ACTIVE_CHARGER':
      return {
        ...state,
        activeChargerIds: state.activeChargerIds.indexOf(action.id) === -1 ? [...state.activeChargerIds, action.id]
          : state.activeChargerIds.filter((id) => id !== action.id),
      };
    case 'TOGGLE_SELECT_ALL_CHARGERS': {
      const allSelected = state.activeChargerIds.length === state.chargers.length;
      const activeChargerIds = allSelected ? [] : state.chargers.map((charger) => charger.c_uuid);

      return { ...state, activeChargerIds };
    }
    case 'SET_COLUMNS_CONFIG':
      return { ...state, columnsConfig: !isUndefined(action.config) && action.config.length ? action.config : [] };
    case 'SET_FW_LIST':
      return { ...state, fwList: action.fwList };
    case 'SET_SELECTED_FW_VERSION':
      return { ...state, selectedFwVersion: action.selectedFwVersion };
    case 'OPEN_CONFIRMATION_DIALOG':
      return { ...state, isConfirmationDialogOpened: action.isOpen };
    default:
      return state;
  }
}

export default multiFwUpdateList;
